/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Item } from './Item';
import {
    ItemFromJSON,
    ItemFromJSONTyped,
    ItemToJSON,
    ItemToJSONTyped,
} from './Item';
import type { ResponseResult } from './ResponseResult';
import {
    ResponseResultFromJSON,
    ResponseResultFromJSONTyped,
    ResponseResultToJSON,
    ResponseResultToJSONTyped,
} from './ResponseResult';

/**
 * 
 * @export
 * @interface ResponseItem
 */
export interface ResponseItem {
    /**
     * 
     * @type {ResponseResult}
     * @memberof ResponseItem
     */
    result: ResponseResult;
    /**
     * 
     * @type {Item}
     * @memberof ResponseItem
     */
    data: Item;
}

/**
 * Check if a given object implements the ResponseItem interface.
 */
export function instanceOfResponseItem(value: object): value is ResponseItem {
    if (!('result' in value) || value['result'] === undefined) return false;
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ResponseItemFromJSON(json: any): ResponseItem {
    return ResponseItemFromJSONTyped(json, false);
}

export function ResponseItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseItem {
    if (json == null) {
        return json;
    }
    return {
        
        'result': ResponseResultFromJSON(json['result']),
        'data': ItemFromJSON(json['data']),
    };
}

export function ResponseItemToJSON(json: any): ResponseItem {
    return ResponseItemToJSONTyped(json, false);
}

export function ResponseItemToJSONTyped(value?: ResponseItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'result': ResponseResultToJSON(value['result']),
        'data': ItemToJSON(value['data']),
    };
}

